export const BUDGET_CODES_STORAGE_KEY = "besarawak_budget_codes_v1";
export const DEFAULT_BUDGET_CODES = [
  { id:"B-001", code:"BE-MKT-001", name:"Marketing", amount:500000, status:"Active" },
  { id:"B-002", code:"BE-OPS-001", name:"Operations", amount:750000, status:"Active" },
  { id:"B-003", code:"BE-IT-001", name:"Information Technology", amount:600000, status:"Active" },
  { id:"B-004", code:"BE-HR-001", name:"Human Resource", amount:300000, status:"Inactive" },
];
const copy=(value)=>JSON.parse(JSON.stringify(value));
export const loadBudgetCodes=()=>{try{const value=JSON.parse(localStorage.getItem(BUDGET_CODES_STORAGE_KEY));return Array.isArray(value)?value:copy(DEFAULT_BUDGET_CODES)}catch(error){return copy(DEFAULT_BUDGET_CODES)}};
export const saveBudgetCodes=(items)=>localStorage.setItem(BUDGET_CODES_STORAGE_KEY,JSON.stringify(items));
